import {
  customerAccessTokenCreate,
  customerAccessTokenCreateWithMultipass,
  customerActivateByUrl,
} from "../api/shopify-user";

interface ICustomer {
  shopifyCustomerId: string;
  email: string;
  phone: string;
  state: "ENABLED" | "DISABLED";
  password?: string;
  multipassToken?: string;
  accountActivationUrl?: string;
}

export const decodeKpToken = async (kpToken: string) => {
  try {
    const response = await fetch("/api/kwikpass/decode-token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ kpToken }),
    });

    const result = await response.json();

    if (result.success) {
      return result.data.customer;
    }
    console.error("Failed to decode KwikPass token:", result.error.message);
    return null;
  } catch (error) {
    console.error("Failed to decode KwikPass token:", error);
    return null;
  }
};

export const getCustomerAccessToken = async (customer: ICustomer) => {
  try {
    if (!customer || !customer?.email || !customer?.password) {
      return null;
    }

    const userTokenData = await customerAccessTokenCreate(
      customer.email,
      customer.password,
    );

    if (!userTokenData?.customerAccessToken?.accessToken) {
      return null;
    }

    return userTokenData?.customerAccessToken?.accessToken;
  } catch (err) {
    console.error("Error getting customer access token:", err);
    return null;
  }
};

export const getCustomerAccessTokenByActivation = async (
  customer: ICustomer,
) => {
  try {
    if (!customer || !customer?.accountActivationUrl || !customer?.password) {
      return null;
    }

    const userTokenData = await customerActivateByUrl(
      customer.accountActivationUrl,
      customer.password,
    );

    if (userTokenData?.customerUserErrors?.length > 0) {
      console.error(
        "Customer activation errors:",
        userTokenData.customerUserErrors,
      );
      return null;
    }

    if (!userTokenData?.customer?.id) {
      return null;
    }

    // After successful activation, get access token using email and password
    const accessTokenData = await customerAccessTokenCreate(
      customer.email,
      customer.password,
    );

    if (!accessTokenData?.customerAccessToken?.accessToken) {
      return null;
    }

    return accessTokenData?.customerAccessToken?.accessToken;
  } catch (err) {
    console.error("Error activating customer account:", err);
    return null;
  }
};

export const getCustomerAccessTokenMultipass = async (customer: ICustomer) => {
  try {
    if (!customer || !customer?.multipassToken) {
      return null;
    }

    const userTokenData = await customerAccessTokenCreateWithMultipass(
      customer.multipassToken,
    );

    if (!userTokenData?.customerAccessToken?.accessToken) {
      return null;
    }

    return userTokenData?.customerAccessToken?.accessToken;
  } catch (err) {
    console.error("Error getting customer access token:", err);
    return null;
  }
};
